import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Modal from 'components/Modal';
import OTP from 'components/OTP';


const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
  },
  paper: {
    boxShadow: theme.shadows[5],
    borderRadius: '12px',
    maxWidth: '600px',
    marginLeft: '200px',
    marginTop: '-200px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 30px',
    },
  },
}));

const OTPModal = ({ isOpen, phoneNumber, onComplete, onSuccess, onCancel, onPhoneNumberClick }) => {

  const classes = useStyles();


  return (
    <Modal
      isOpen={isOpen}
      modalClassName={classes.modal}
      paperClassName={classes.paper}
      backdropClassName={classes.backdrop}
    >
      <OTP
        phoneNumber={phoneNumber}
        onCancel={onCancel}
        onComplete={onComplete}
        onSuccess={onSuccess}
        onPhoneNumberClick={onPhoneNumberClick}
      />
    </Modal>
  );
};

OTPModal.propTypes = {
  isOpen: PropTypes.bool,
  phoneNumber: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPhoneNumberClick: PropTypes.func,
};

export default OTPModal;